import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment as env } from 'src/environment/environment';
import { IUser } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _http: HttpClient = inject(HttpClient);

  getUser(): Observable<IUser> {
    return this._http.get<IUser>(`${env.apiGateway}/login`);
  }
}
